module.exports = __webpack_public_path__ + "img/chadle1_3.95406305.png";